import { orderBboxItemsByHilbertCurve } from "utils/math/orderBboxItemsByHilbertCurve";
import { sumElementMultipliers } from "../sumElementMultipliers";
import type { BulkAddPlanElementsArgs } from "./types";

export const bulkAddPlanElements = ({
  plan,
  elements,
}: BulkAddPlanElementsArgs) => {
  const byGroupId = { ...plan.groupedElements.byGroupId };
  const newGroupIds: string[] = [];
  const newGroupMeta = { ...plan.groupMeta };
  const modifiedGroups = new Set<string>();

  for (const { element, elementTypeId, groupLabel } of elements) {
    const isNewGroup = !byGroupId[groupLabel];

    byGroupId[groupLabel] = [...(byGroupId[groupLabel] ?? []), element];
    modifiedGroups.add(groupLabel);

    if (isNewGroup) {
      newGroupIds.push(groupLabel);
      newGroupMeta[groupLabel] = {
        element_type_id: elementTypeId,
        // Matches backend: new element types created via bulk-create are CONFIDENT
        nameStatus: "confident",
      };
    }
  }

  for (const groupLabel of modifiedGroups) {
    byGroupId[groupLabel] = orderBboxItemsByHilbertCurve({
      elements: byGroupId[groupLabel],
    });
  }

  const groupIds =
    newGroupIds.length > 0
      ? [...plan.groupedElements.groupIds, ...newGroupIds]
      : plan.groupedElements.groupIds;

  return {
    ...plan,
    groupedElements: {
      ...plan.groupedElements,
      byGroupId,
      groupIds,
      all: {
        ...plan.groupedElements.all,
        count:
          plan.groupedElements.all.count +
          sumElementMultipliers({
            elements: elements.map((entry) => entry.element),
          }),
      },
    },
    groupMeta: newGroupMeta,
  };
};
